import Text from "./Typography";

export default Text;
